import { useState, useEffect } from 'react'
export interface ISelectedAllPayment extends IGetAllPayment {
    isSelected: boolean
}
export default function useSetTotalPayment(payments: ISelectedAllPayment[]) {
    const [total, setTotal] = useState<number>(0)
    const [commission, setCommission] = useState<number>(0)
    useEffect(() => {
        if (payments && payments.length > 0) {
            const reduceTotal = payments
                .filter((item) => item.isSelected === true)
                .reduce(
                    (acc, current) => acc + current.amount,

                    0
                )
            const reduceCommission = payments
                .filter((item) => item.isSelected === true)
                .reduce((acc, current) => acc + current.commission, 0)
            setTotal(Number(reduceTotal))
            setCommission(Number(reduceCommission))
        }
    }, [payments])
    return { total, commission }
}
